<script>
import getErrorMessage from '@/modules/server-errors';

//
// NOTE: This component is intentionally not translated.
//

export default {
  name: 'SwitchDialog',
  data() {
    return {
      dialogVisible: false,
      isSubmitting: false,
      paymentInterval: 'month',
      plan: 'business'
    };
  },
  methods: {
    show(options) {
      options = options || {};
      this.plan = options.plan || 'business';
      this.paymentInterval = options.paymentInterval || 'month';
      this.dialogVisible = true;
    },

    hide() {
      this.dialogVisible = false;
    },

    handleSubmit() {
      this.isSubmitting = true;
      this.$http
        .put('/account/subscription', {
          cancelAtPeriodEnd: false,
          plan: this.plan,
          paymentInterval: this.paymentInterval
        })
        .then(res => {
          this.account = res.data.account;
          this.$store.commit('setAccount', this.account);
          this.hide();
        })
        .catch(err => {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: getErrorMessage(err.response.data.code)
          });
        })
        .finally(() => (this.isSubmitting = false));
    }
  }
};
</script>

<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="Switch Plan"
    class="switch-plan-dialog"
  >
    <el-form
      ref="form"
      @submit="handleSubmit"
    >
      <el-row :gutter="20">
        <el-col :span="14">
          <!-- Plan -->
          <el-form-item>
            <el-select
              v-model="plan"
              placeholder=""
            >
              <el-option label="Business" value="business" />
              <el-option label="Agency" value="agency" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <!-- Payment interval -->
          <el-form-item>
            <el-select
              v-model="paymentInterval"
              placeholder=""
            >
              <el-option v-if="plan === 'business'" label="$12/month" value="month" />
              <el-option v-if="plan === 'business'" label="$120/year" value="year" />
              <el-option v-if="plan === 'agency'" label="$24/month" value="month" />
              <el-option v-if="plan === 'agency'" label="$240/year" value="year" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <p>
        Your account will be charged or credited a prorated amount based on your usage. Changing
        your payment interval will also chanage your billing date.
      </p>
    </el-form>

    <!-- Footer -->
    <span slot="footer">
      <el-button
        :loading="isSubmitting"
        type="primary"
        @click="handleSubmit"
      >
        Switch Plan
      </el-button>
    </span>
  </el-dialog>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.switch-plan-dialog {
  .el-form-item {
    margin-bottom: 0.25rem;
  }

  /deep/ .el-dialog {
    width: 25rem;

    .el-dialog__body > :last-child {
      margin-bottom: 0;
    }

    .el-dialog__footer {
      position: relative;

      .el-button {
        width: 100%;
        padding: 1rem;
      }
    }
  }
}
</style>
